import React, { useEffect, useState } from "react";
import { brl } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Ruler } from "lucide-react";
import { calcLinear } from "@/lib/linearPricing";

export const LinearCalcSummary = ({ product, meters }) => {
  const c = calcLinear(product, meters);
  return (
    <div className="text-sm space-y-1 border rounded-lg p-3 bg-slate-50" data-testid="linear-calc-summary">
      <div className="flex justify-between"><span>Preço por metro</span><span className="kpi-num">{brl(c.rate)}</span></div>
      <div className="flex justify-between"><span>{c.meters} m × {brl(c.rate)}</span><span className="kpi-num">{brl(c.raw)}</span></div>
      {c.minApplied && <div className="text-xs text-amber-700">Valor mínimo aplicado: {brl(product.min_charge)}</div>}
      <div className="flex justify-between font-semibold border-t pt-1"><span>Total sugerido</span><span className="kpi-num text-blue-600" data-testid="linear-suggested-total">{brl(c.total)}</span></div>
    </div>
  );
};

export const LinearServiceDialog = ({ product, onClose, onConfirm }) => {
  const [meters, setMeters] = useState("");
  const [total, setTotal] = useState("");
  useEffect(() => { setMeters(""); setTotal(""); }, [product]);

  const calc = product ? calcLinear(product, meters) : null;
  const confirm = () => {
    if (!(calc.meters > 0)) return;
    const final = total === "" ? calc.total : Number(total);
    onConfirm({ meters: calc.meters, total: final });
  };

  return (
    <Dialog open={!!product} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-sm" data-testid="linear-service-dialog">
        <DialogHeader><DialogTitle className="font-display flex items-center gap-2"><Ruler className="w-5 h-5 text-blue-600" /> {product?.name}</DialogTitle></DialogHeader>
        {product && (
          <div className="space-y-3">
            <div><Label>Metragem linear (m)</Label>
              <Input type="number" step="0.01" min="0" autoFocus value={meters} onChange={(e) => setMeters(e.target.value)} data-testid="linear-meters-input" /></div>
            <LinearCalcSummary product={product} meters={meters} />
            <div><Label className="text-xs">Valor final (opcional, para ajustar o sugerido)</Label>
              <Input type="number" step="0.01" placeholder={calc.total.toFixed(2)} value={total} onChange={(e) => setTotal(e.target.value)} data-testid="linear-final-input" /></div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={confirm} disabled={!(calc?.meters > 0)} className="bg-blue-600 hover:bg-blue-700" data-testid="linear-add-btn">Adicionar ao carrinho</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
